import { Injectable, inject } from '@angular/core';
import {
  NucleusApplicationConfigContract,
  NucleusPermission,
} from '@nucleus/user-ui';
import { ApplicationConfigService } from '../application-config.service';
import { UIConfigurationService } from '../ui-configuration.service';

/**
 * Tasksense ApplicationConfigService → NucleusApplicationConfigContract.
 *
 * tasksense's Permission carries a `group` field; the lib's NucleusPermission
 * uses `category`. Map across so the role tree groups correctly.
 *
 * Tasksense uses authority-based access, so showsRequestAccessTab() returns
 * true (matches the local UIConfigurationService flag).
 */
@Injectable({ providedIn: 'root' })
export class TasksenseAppConfigAdapter implements NucleusApplicationConfigContract {
  private readonly config = inject(ApplicationConfigService);
  private readonly uiConfig = inject(UIConfigurationService);

  getPermissions(): NucleusPermission[] {
    return this.config.getPermissions().map((p) => ({
      permission: p.permission,
      description: p.description,
      category: p.group,
    }));
  }

  getUserId(): string {
    return this.config.getUserId();
  }

  showsRequestAccessTab(): boolean {
    return this.uiConfig.showsRequestAccessTab();
  }
}
